export default {
  title: 'Campaigns',
  actions: {
    create: 'Create a campaign'
  },
  empty: {
    title: 'No campaign',
    message: 'To create a campaign, nothing could be easier, just click on the following link:'
  },
  state: {
    published: 'published',
    testing: 'testing',
    terminated: 'finished'
  },
  modal: {
    create: {
      title: 'Create a campaign',
      fields: {
        name: 'Name',
        period: 'Restrict the period',
        date: {
          start: 'Start',
          end: 'End'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/campaign.js